import moment from 'moment';
import { FORMAT } from '../../../constants';

export default ({ value }) => moment(value).format(FORMAT.DATE);
